<template>
  <div
    :class="themeClasses"
    class="mm-button-group">
    <slot></slot>
  </div>
</template>

<script>
import themeSize from "../../mixins/theme-size"

export default {
  name: "mm-button-group",
  mixins: [themeSize],
  provide() {
    return {
      "mm-button-group": this,
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: String,
  },
}
</script>
